"use strict";

exports.__esModule = true;
exports.createStorages = void 0;
var _storage = require("../utils/storage");
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const createStorages = api => {
  return {
    scheduler: () => {
      return _storage.Storage.create({
        api: api,
        path: 'query.scheduler.agenda.entries',
        params: []
      });
    },
    dexSavingRewardRates: () => {
      return _storage.Storage.create({
        api: api,
        path: 'query.incentives.dexSavingRewardRates.entries',
        params: []
      });
    },
    incentiveRewardAmounts: () => {
      return _storage.Storage.create({
        api: api,
        path: 'query.incentives.incentiveRewardAmounts.entries',
        params: []
      });
    },
    poolInfos: () => {
      return _storage.Storage.create({
        api: api,
        path: 'query.rewards.poolInfos.entries',
        params: []
      });
    },
    claimRewardDeductionRates: () => {
      return _storage.Storage.create({
        api: api,
        path: 'query.incentives.claimRewardDeductionRates.entries',
        params: []
      });
    },
    userSharesAndWithdrawnRewards: (id, address) => {
      return _storage.Storage.create({
        api: api,
        path: 'query.rewards.sharesAndWithdrawnRewards',
        params: [id, address]
      });
    },
    pendingRewards: (id, address) => {
      return _storage.Storage.create({
        api: api,
        path: 'query.incentives.pendingMultiRewards',
        params: [id, address]
      });
    }
  };
};
exports.createStorages = createStorages;